import { t } from 'i18next';
import { CollapsibleCard } from '../../../../components/CollapsibleCard';

export const RequestContent = ({ dataRequest, headersFetch, companyID, isRefreshing }) => {
  const { data, isLoading, isFetching, error } = dataRequest;

  if (error) return <div>{t('OnboardingRequestFailed')}</div>;

  if (isLoading || isFetching || isRefreshing)
    return (
      <div className="flex flex-row items-center justify-center gap-2">
        <div className="h-5 w-5 animate-spin rounded-full border-2 border-black"></div>
        <span>{t('OnboardingRequestLoadingData')}</span>
      </div>
    );

  return (
    <>
      <CollapsibleCard dataResponse={data} headers={headersFetch} companyID={companyID} />
    </>
  );
};
